import { faSearch, faXmark } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { JoonUIColor } from "@joonapp/web-shared"

import { useAllQuestsSearchStore } from "./hooks/useAllQuestsSearchStore"

const SearchInput = () => {
  const { searchQuery, setSearchQuery } = useAllQuestsSearchStore()

  const handleClearSearch = () => {
    setSearchQuery("")
  }

  return (
    <div className="mb-4 flex items-center gap-2 bg-white rounded-lg p-2 px-3 border border-gray-200 focus-within:outline-2 focus-within:outline-indigo-300 focus-within:border-blue-500">
      <input
        type="text"
        placeholder="Tap to search..."
        className="w-full text-base bg-transparent font-normal"
        style={{ outline: "none", color: JoonUIColor.text.primary }}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
      {searchQuery ? (
        <button onClick={handleClearSearch}>
          <FontAwesomeIcon
            icon={faXmark}
            color={JoonUIColor.text.disabled}
            fontSize={16}
          />
        </button>
      ) : (
        <FontAwesomeIcon
          icon={faSearch}
          color={JoonUIColor.text.disabled}
          fontSize={16}
        />
      )}
    </div>
  )
}

export default SearchInput
